import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Button, Stack, Typography } from '@mui/material'
import { useBulkPaymentStepperContext } from '../../contexts/BulkPaymentStepperContext'
import Footer from './Footer'
import VendorSelect from './VendorSelect'
export default function Step1() {
  const { vendorId, setActiveStep } = useBulkPaymentStepperContext()
  return (
    <Stack spacing={2}>
      <Stack spacing={2} maxWidth="50%" mx="auto" alignSelf="center">
        <Typography variant="body2" mb={2}>
          First, select the vendor whose payment you're entering.
        </Typography>
        <VendorSelect />
        <Typography variant="caption" mt={4}>
          Note: This list is filtered to only show vendors with outstanding commission. If you'd like to enter payments
          for a vendor not listed here, please create a new RFQ with a PO for that vendor.
        </Typography>
      </Stack>
      <Footer>
        <Button variant="contained" color="primary" sx={{ flexBasis: '50%' }} endIcon={<NavigateBeforeIcon />} disabled>
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ flexBasis: '50%' }}
          disabled={vendorId === undefined}
          onClick={() => setActiveStep(1)}
          endIcon={<NavigateNextIcon />}
        >
          Next
        </Button>
      </Footer>
    </Stack>
  )
}
